import type { InvoiceImportEvidence } from "./invoice-settlement";
export type InvoiceCsvFormat = InvoiceImportEvidence["format"];
export interface InvoiceCsvRequest {
  format: InvoiceCsvFormat;
  csv: string;
  matches: Record<string, { id: string; version: number }>;
}
export interface InvoiceImportRow {
  number: string; sourceClient: string; clientId: string | null; status: InvoiceImportEvidence["status"];
  issueDate: string; dueDate: string; paidOn: string | null; lines: number; totalMinor: number;
  discountBasisPoints: number | null;
  lineItems: { description: string; quantityThousandths: number; rateMinor: number; totalMinor: number }[];
  action: "import" | "skip" | "conflict"; invoiceId?: string; errors: string[];
}
export interface InvoiceImportPreview {
  fileSha256: string; digest: string; ready: boolean; sourceClients: string[];
  invoices: InvoiceImportRow[]; errors: string[]; alreadyImported?: boolean;
}
export interface InvoiceImportReceipt {
  source: string; fileSha256: string; format: InvoiceCsvFormat; completedAt: string;
  imported: number; skipped: number; rows: { number: string; invoiceId: string; action: "import" | "skip" }[];
  paymentsCreated: 0; emailsSent: 0;
}
export const SIGNALBILL_INVOICE_COLUMNS = ["Client", "Invoice number", "Issue date", "Due date", "Status", "Date paid", "Description", "Quantity", "Rate", "Discount percentage", "Currency"];
export const SIGNALBILL_INVOICE_TEMPLATE = SIGNALBILL_INVOICE_COLUMNS.join(",") + "\r\n";
